// eslint-disable-next-line import/prefer-default-export
export const isLowerCase = (str) =>
  str === str.toLowerCase() && str !== str.toUpperCase();
